import flatpickr from 'flatpickr';
import { German } from 'flatpickr/dist/l10n/de.js';

// Datepicker

const applicationForms = Array.from(document.querySelectorAll('.js-applicationForm'));

applicationForms.forEach(form => {
	const endDateInput = form.querySelector('.js-endDate');
	let endDatePicker;
	if (endDateInput) {
		endDatePicker = flatpickr(endDateInput, {
			allowInput: true,
			dateFormat: 'd.m.Y',
			minDate: new Date().fp_incr(1),
			locale: German,
		});
	}

	const startDateInput = form.querySelector('.js-startDate');
	if (startDateInput && startDateInput.tagName === 'INPUT') {
		flatpickr(startDateInput, {
			allowInput: true,
			dateFormat: 'd.m.Y',
			minDate: new Date().fp_incr(1),
			locale: German,

			onClose: (selectedDates, dateStr) => {
				endDatePicker.set && endDatePicker.set('minDate', dateStr);
			},
		});
	}
});
